export default __webpack_public_path__ + "static/media/alterReservation.6c512c59.svg";